import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-setting-sidebar',
  templateUrl: './common-setting-sidebar.component.html',
  styleUrls: ['./common-setting-sidebar.component.css']
})
export class CommonSettingSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
